import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66cd805e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "最新筹码态势", -1))
const _hoisted_2 = { class: "flex-row" }
const _hoisted_3 = { class: "table-wrap flex-1" }
const _hoisted_4 = { class: "custom-table" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "筹码状态", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "当前状态区间", -1))
const _hoisted_7 = { class: "value" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "当前状态区间涨幅", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "历史状态区间涨幅", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_11 = { class: "table-wrap flex-1" }
const _hoisted_12 = { class: "custom-table" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "筹码形态", -1))
const _hoisted_14 = { class: "value red-text" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "形态说明", -1))
const _hoisted_16 = { class: "value" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "当前形态趋势", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "双峰反弹空间", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title flex-between" }, [
  /*#__PURE__*/_createElementVNode("span", null, "历史筹码形态统计"),
  /*#__PURE__*/_createElementVNode("span", { class: "sub-title" }, "近360个交易日")
], -1))
const _hoisted_20 = { class: "custom-table full-width text-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "筹码形态"),
    /*#__PURE__*/_createElementVNode("th", null, "发生次数"),
    /*#__PURE__*/_createElementVNode("th", null, "3日涨幅"),
    /*#__PURE__*/_createElementVNode("th", null, "10日涨幅"),
    /*#__PURE__*/_createElementVNode("th", null, "20日涨幅")
  ])
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "-", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "-", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "-", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "-", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.theme)
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _hoisted_5,
              _createElementVNode("td", {
                class: _normalizeClass(["value", _ctx.stateColor(_ctx.situationData.state)])
              }, _toDisplayString(_ctx.situationData.state || '-'), 3)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_6,
              _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.situationData.stateStart ? _ctx.formatTime(_ctx.situationData.stateStart) + '~至今' : '~'), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_8,
              _createElementVNode("td", {
                class: _normalizeClass(["value", _ctx.valueColorClass(_ctx.situationData.statePxRateCurrent)])
              }, _toDisplayString(_ctx.formatRate(_ctx.situationData.statePxRateCurrent)), 3)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_9,
              _createElementVNode("td", {
                class: _normalizeClass(["value", _ctx.valueColorClass(_ctx.situationData.statePxRateHistory)])
              }, _toDisplayString(_ctx.formatRate(_ctx.situationData.statePxRateHistory)), 3)
            ])
          ])
        ])
      ]),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("table", _hoisted_12, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _hoisted_13,
              _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.situationData.shape || '-'), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_15,
              _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.situationData.shapeDescribe || '-'), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_17,
              _createElementVNode("td", {
                class: _normalizeClass(["value", _ctx.trendColor(_ctx.situationData.shapeTrendColor)])
              }, _toDisplayString(_ctx.situationData.shapeTrend || '-'), 3)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_18,
              _createElementVNode("td", {
                class: _normalizeClass(["value", _ctx.valueColorClass(_ctx.situationData.doublePeaksRebound)])
              }, _toDisplayString(_ctx.formatRate(_ctx.situationData.doublePeaksRebound)), 3)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_19,
    _createElementVNode("table", _hoisted_20, [
      _hoisted_21,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.situationData.shapeHis, (item, index) => {
          return (_openBlock(), _createElementBlock("tr", { key: index }, [
            _createElementVNode("td", null, _toDisplayString(item.shape), 1),
            _createElementVNode("td", null, _toDisplayString(item.number) + "次", 1),
            _createElementVNode("td", {
              class: _normalizeClass(_ctx.valueColorClass(item.pxRateDay3))
            }, _toDisplayString(_ctx.formatRate(item.pxRateDay3)), 3),
            _createElementVNode("td", {
              class: _normalizeClass(_ctx.valueColorClass(item.pxRateDay10))
            }, _toDisplayString(_ctx.formatRate(item.pxRateDay10)), 3),
            _createElementVNode("td", {
              class: _normalizeClass(_ctx.valueColorClass(item.pxRateDay20))
            }, _toDisplayString(_ctx.formatRate(item.pxRateDay20)), 3)
          ]))
        }), 128)),
        (!_ctx.situationData.shapeHis || _ctx.situationData.shapeHis.length === 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(['低位锁定', '双峰密集', '高位震荡', '低位震荡', '高位密集', '低位密集', '其他形态'], (shapeName) => {
              return _createElementVNode("tr", { key: shapeName }, [
                _createElementVNode("td", null, _toDisplayString(shapeName), 1),
                _hoisted_22,
                _hoisted_23,
                _hoisted_24,
                _hoisted_25
              ])
            }), 64))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}